
// 智能投放
export default {
  path: '/qianchuan/putin',
  name: 'qputin',
  component: resolve => require(['@/views/qianchuan/putin'], resolve),
  meta: {
    keepAlive: true,
    title: '投放',
    code: 'page:putin',
    activeName: '/putin',
    permission: 'advertising',
    name: 'qcmanage'
  },
  children: [
    {
      path: 'qcmanage',
      name: 'qcmanage',
      component: resolve => require(['@/views/qianchuan/putin/manage'], resolve),
      meta: {
        keepAlive: true,
        title: '投放管理',
        iconName: 'icon-toufangguanli',
        permission: 'adRelease',
        subMenuShow: false
      },
      subMenu: [
        {
          name: 'qc-account',
          title: '投放账户'

        },
        {
          name: 'qc-group',
          title: '广告组'
        },
        {
          name: 'qc-plan',
          title: '计划'
        },
        {
          name: 'qc-creative',
          title: '创意'
        }
      ],
      children: [
        {
          path: 'qc-account',
          name: 'qc-account',
          component: resolve => require(['@/views/qianchuan/putin/putInManage'], resolve),
          meta: {
            keepAlive: true,
            title: '投放账户'
          }
        },
        {
          path: 'qc-group',
          name: 'qc-group',
          component: resolve => require(['@/views/qianchuan/putin/putInManage'], resolve),
          meta: {
            keepAlive: true,
            title: '广告组'
          }
        },
        {
          path: 'qc-plan',
          name: 'qc-plan',
          component: resolve => require(['@/views/qianchuan/putin/putInManage'], resolve),
          meta: {
            keepAlive: true,
            title: '计划'
          }
        },
        {
          path: 'qc-creative',
          name: 'qc-creative',
          component: resolve => require(['@/views/qianchuan/putin/putInManage'], resolve),
          meta: {
            keepAlive: true,
            title: '创意'
          }
        },
        {
          path: 'qc-copyPlan',
          name: 'qc-copyPlan',
          component: resolve => require(['@/views/qianchuan/putin/copyPlan'], resolve),
          meta: {
            keepAlive: true,
            title: '克隆计划'
          }
        }
      ]
    },
    {
      path: 'strategy',
      name: 'qcstrategy',
      component: resolve => require(['@/views/qianchuan/putin/strategy/index'], resolve),
      meta: {
        keepAlive: true,
        title: '策略投放',
        iconName: 'icon-celveguanli',
        permission: 'strategy'
      },
      children: [
        {
          path: 'create',
          name: 'qccreateStrategy',
          component: resolve => require(['@/views/qianchuan/putin/strategy/create'], resolve),
          meta: {
            keepAlive: true,
            sidebar: true,
            title: '新建策略'
          }
        },
        {
          path: 'template',
          name: 'qcTemplate',
          component: resolve => require(['@/views/qianchuan/putin/strategy/template'], resolve),
          meta: {
            keepAlive: true,
            sidebar: true,
            title: '智能模板'
          }
        }
      ]
    }
    // {
    //   path: 'directional',
    //   name: 'qcdirectional',
    //   component: resolve => require(['@/views/qianchuan/putin/directional'], resolve),
    //   meta: {
    //     keepAlive: true,
    //     title: '定向管理',
    //     iconName: 'icon-dingxiangguanli',
    //     permission: 'directional'
    //   },
    //   children: [
    //     {
    //       path: 'addBaseDirectional',
    //       name: 'qcaddBaseDirectional',
    //       component: resolve => require(['@/views/qianchuan/putin/directional/addBaseDirectional'], resolve),
    //       meta: {
    //         keepAlive: true,
    //         title: '新建基础定向包'
    //       }
    //     },
    //     {
    //       path: 'addReleasedDirectional',
    //       name: 'qcaddReleasedDirectional',
    //       component: resolve => require(['@/views/qianchuan/putin/directional/addReleasedDirectional'], resolve),
    //       meta: {
    //         keepAlive: true,
    //         title: '新建投放定向包'
    //       }
    //     }
    //   ]
    // },
    // {
    //   path: 'crowd',
    //   name: 'qccrowd',
    //   component: resolve => require(['@/views/qianchuan/putin/crowd'], resolve),
    //   meta: {
    //     keepAlive: true,
    //     title: '人群管理',
    //     iconName: 'icon-renqunguanli',
    //     permission: 'crowd'
    //   }
    // },
    // {
    //   path: 'channel',
    //   name: 'qcchannel',
    //   component: resolve => require(['@/views/qianchuan/putin/channel'], resolve),
    //   meta: {
    //     keepAlive: true,
    //     title: '商品/抖音号',
    //     iconName: 'icon-qudaoguanli',
    //     permission: 'keywords'
    //   }
    // },
    // {
    //   path: 'creativeComponents',
    //   name: 'qccreativeComponents',
    //   component: resolve => require(['@/views/qianchuan/putin/creativeComponents'], resolve),
    //   meta: {
    //     keepAlive: true,
    //     title: '创意组件',
    //     iconName: 'icon-chuangyizujian-copy',
    //     permission: 'keywords'
    //   }
    // }
  ]
}



// WEBPACK FOOTER //
// ./src/router/qianchuan/putin.js